import { render } from "./VatToggle.vue?vue&type=template&id=f11870fe&scoped=true"
import script from "./VatToggle.vue?vue&type=script&lang=js"
export * from "./VatToggle.vue?vue&type=script&lang=js"

import "./VatToggle.vue?vue&type=style&index=0&id=f11870fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f11870fe"]])

export default __exports__